export default {
    open: "Answer now",
    approve: "Approve now",
    impersonation: {
        title: "You are ordering on behalf of «{name}»",
        cta: "Switch back to myself",
    },
    "You have an unapproved orders": "You have orders to approve",
    "You have orders to approve": "You have orders to approve"
}